(function () {
  'use strict';

  var MODAL_ID = 'bed-set-upgrade-modal';
  var STYLE_ID = 'bed-set-savings-style';

  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function productText(product) {
    if (!product) return '';
    return normalise([
      product.type,
      product.title,
      product.handle,
      Array.isArray(product.bundle_items) ? product.bundle_items.join(' ') : ''
    ].join(' '));
  }

  function isBedSet(product) {
    var text = productText(product);
    return (
      text.indexOf('bed set') !== -1 ||
      text.indexOf('bedding set') !== -1 ||
      (
        text.indexOf('duvet cover') !== -1 &&
        text.indexOf('fitted sheet') !== -1 &&
        text.indexOf('pillowcase') !== -1
      )
    );
  }

  function matchesColour(product, colourKey) {
    if (!product || !colourKey) return false;
    var productWords = normalise([product.title, product.handle].join(' ')).split(' ');
    var colourWords = colourKey.split(' ').filter(Boolean);
    return colourWords.length > 0 && colourWords.every(function (word) {
      return productWords.indexOf(word) !== -1;
    });
  }

  function findVariant(component, variantId) {
    var products = Array.isArray(component.setProducts) ? component.setProducts : [];
    var id = String(variantId);

    for (var i = 0; i < products.length; i += 1) {
      var variants = Array.isArray(products[i].variants) ? products[i].variants : [];
      for (var j = 0; j < variants.length; j += 1) {
        if (String(variants[j].id) === id) {
          return { product: products[i], variant: variants[j] };
        }
      }
    }
    return null;
  }

  function getComponent() {
    var buttons = document.querySelectorAll('[data-set-add]');

    for (var i = 0; i < buttons.length; i += 1) {
      var root = buttons[i].closest('[x-data]');
      if (!root) continue;

      if (window.Alpine && typeof window.Alpine.$data === 'function') {
        try {
          var component = window.Alpine.$data(root);
          if (
            component &&
            Array.isArray(component.selectedItems) &&
            component.selectedItems.length &&
            Array.isArray(component.setProducts)
          ) {
            return component;
          }
        } catch (error) {}
      }

      var stack = root._x_dataStack;
      if (Array.isArray(stack)) {
        for (var j = 0; j < stack.length; j += 1) {
          if (
            stack[j] &&
            Array.isArray(stack[j].selectedItems) &&
            stack[j].selectedItems.length &&
            Array.isArray(stack[j].setProducts)
          ) {
            return stack[j];
          }
        }
      }
    }
    return null;
  }

  function activeColourKey(component) {
    var linked = Array.isArray(component.linkedProducts) ? component.linkedProducts : [];
    var handle = component.currentHandle ||
      window.location.pathname.split('/products/')[1] || '';
    var current = linked.find(function (product) {
      return product && product.handle === handle;
    });
    return normalise(current && current.dynamic_value ? current.dynamic_value : '');
  }

  function replacementSummary() {
    var component = getComponent();
    if (!component) return null;

    var colourKey = activeColourKey(component);
    if (!colourKey) return null;

    var lines = [];
    var total = 0;

    component.selectedItems.forEach(function (item) {
      var match = findVariant(component, item.id);
      if (
        !match ||
        !match.variant ||
        isBedSet(match.product) ||
        !matchesColour(match.product, colourKey)
      ) {
        return;
      }

      var quantity = Math.max(1, Number(item.quantity || 1));
      var lineTotal = Number(match.variant.price || 0) * quantity;
      total += lineTotal;

      lines.push({
        title: match.product.title || item.title || '',
        variant: match.variant.title && match.variant.title !== 'Default Title'
          ? match.variant.title
          : '',
        quantity: quantity,
        total: lineTotal
      });
    });

    return { lines: lines, total: total };
  }

  function money(pence) {
    var amount = Number(pence || 0) / 100;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(amount);
    } catch (error) {
      return '£' + amount.toFixed(2);
    }
  }

  function selectedBedSetPrice(modal) {
    var select = modal.querySelector('#bed-set-upgrade-select');
    if (!select || !select.options.length) return 0;

    var option = select.options[select.selectedIndex];
    var text = String(option ? option.textContent : '');
    var pound = text.lastIndexOf('£');
    if (pound === -1) return 0;

    var amount = parseFloat(
      text.slice(pound + 1)
        .split(',').join('')
        .trim()
    );

    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function setText(element, text) {
    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '#bed-set-upgrade-modal .bed-set-upgrade__comparison{margin:0 0 16px;padding:14px;border:1px solid #d8d8d8;background:#fff}' +
      '#bed-set-upgrade-modal .bed-set-upgrade__comparison-heading{display:block;margin-bottom:10px;color:#2F4C75;font-size:14px}' +
      '#bed-set-upgrade-modal .bed-set-upgrade__comparison-line,#bed-set-upgrade-modal .bed-set-upgrade__comparison-total{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;font-size:13px;line-height:1.4}' +
      '#bed-set-upgrade-modal .bed-set-upgrade__comparison-line span,#bed-set-upgrade-modal .bed-set-upgrade__comparison-total span{min-width:0;flex:1 1 auto}' +
      '#bed-set-upgrade-modal .bed-set-upgrade__comparison-line strong,#bed-set-upgrade-modal .bed-set-upgrade__comparison-total strong{flex:0 0 auto;white-space:nowrap}' +
      '#bed-set-upgrade-modal .bed-set-upgrade__comparison-line+.bed-set-upgrade__comparison-line{margin-top:6px}' +
      '#bed-set-upgrade-modal .bed-set-upgrade__comparison-total{margin-top:9px;padding-top:9px;border-top:1px solid #e3e3e3}' +
      '#bed-set-upgrade-modal .bed-set-upgrade__saving{margin-top:12px;padding-top:10px;border-top:1px solid #e3e3e3;text-align:center;font-size:15px;font-weight:700;line-height:1.4}' +
      '#bed-set-upgrade-modal .bed-set-upgrade__saving--positive{color:#2F4C75}' +
      '#bed-set-upgrade-modal .bed-set-upgrade__saving--neutral{color:#555}';
    document.head.appendChild(style);
  }

  function createRow(label, value, className) {
    var row = document.createElement('div');
    row.className = className;

    var left = document.createElement('span');
    left.textContent = label;

    var right = document.createElement('strong');
    right.textContent = value;

    row.appendChild(left);
    row.appendChild(right);
    return row;
  }

  function render() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return;

    var summary = replacementSummary();
    if (!summary || !summary.lines.length) return;

    addStyles();

    var box = modal.querySelector('.bed-set-upgrade__comparison');
    if (!box) {
      box = document.createElement('div');
      box.className = 'bed-set-upgrade__comparison';
      box.setAttribute('aria-live', 'polite');

      var heading = document.createElement('strong');
      heading.className = 'bed-set-upgrade__comparison-heading';
      heading.textContent = 'Your Selected Items';
      box.appendChild(heading);

      var lines = document.createElement('div');
      lines.className = 'bed-set-upgrade__comparison-lines';

      summary.lines.forEach(function (line) {
        var label = line.quantity + ' × ' + line.title;
        if (line.variant) label += ' — ' + line.variant;
        lines.appendChild(
          createRow(label, money(line.total), 'bed-set-upgrade__comparison-line')
        );
      });
      box.appendChild(lines);

      var selectedRow = createRow(
        'Selected Items Total',
        '',
        'bed-set-upgrade__comparison-total'
      );
      selectedRow.querySelector('strong').setAttribute('data-selected-total', '');
      box.appendChild(selectedRow);

      var bedSetRow = createRow(
        'Bed Set',
        '',
        'bed-set-upgrade__comparison-total'
      );
      bedSetRow.querySelector('strong').setAttribute('data-bed-set-total', '');
      box.appendChild(bedSetRow);

      var saving = document.createElement('div');
      saving.className = 'bed-set-upgrade__saving';
      saving.setAttribute('data-saving', '');
      box.appendChild(saving);

      var details = modal.querySelector('.bed-set-upgrade__details');
      var warning = modal.querySelector('.bed-set-upgrade__warning');
      if (details) {
        details.insertAdjacentElement('afterend', box);
      } else if (warning && warning.parentNode) {
        warning.parentNode.insertBefore(box, warning);
      } else {
        return;
      }
    }

    var bedSetTotal = selectedBedSetPrice(modal);
    var difference = summary.total - bedSetTotal;
    var selectedEl = box.querySelector('[data-selected-total]');
    var bedSetEl = box.querySelector('[data-bed-set-total]');
    var savingEl = box.querySelector('[data-saving]');

    setText(selectedEl, money(summary.total));
    setText(bedSetEl, money(bedSetTotal));

    if (savingEl) {
      savingEl.classList.remove(
        'bed-set-upgrade__saving--positive',
        'bed-set-upgrade__saving--neutral'
      );

      if (summary.total <= 0 || bedSetTotal <= 0) {
        setText(savingEl, '');
      } else if (difference > 0) {
        var percent = Math.round((difference / summary.total) * 100);
        setText(savingEl, 'You Save ' + money(difference) + ' (' + percent + '%)');
        savingEl.classList.add('bed-set-upgrade__saving--positive');
      } else if (difference === 0) {
        setText(savingEl, 'Same Price As Selected Items');
        savingEl.classList.add('bed-set-upgrade__saving--neutral');
      } else {
        setText(savingEl, 'Upgrade to the Bed Set for ' + money(Math.abs(difference)) + ' more');
        savingEl.classList.add('bed-set-upgrade__saving--neutral');
      }
    }

    var select = modal.querySelector('#bed-set-upgrade-select');
    if (select && select.getAttribute('data-savings-bound') !== 'true') {
      select.setAttribute('data-savings-bound', 'true');
      select.addEventListener('change', render);
    }
  }

  var observer = new MutationObserver(render);

  function start() {
    render();
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
